import React from 'react';
import TableSettings from '../../shared/components/TableSettings';
import SortPopover from './SortPopover';

function ReportingTableToolbar({
  title,
  exportUrl,
  onExport,
  tableSettingsOpen,
  setTableSettingsOpen,
  visibleColumns,
  hiddenColumns,
  onColumnsChange,
  sortRules,
  sortPopoverOpen,
  setSortPopoverOpen,
  sortableColumns,
  sortTypes,
  onSortRuleChange,
  onAddSortRule,
  onRemoveSortRule,
  isMobile,
  extraButtons,
}) {
  return (
    <div className="d-flex align-items-center justify-content-between" style={{ padding: '16px 24px', borderBottom: '1px solid var(--sl-bg-tertiary, #f2f4f7)' }}>
      <h6 style={{ fontWeight: 700, fontSize: 16, margin: 0, color: 'var(--sl-text-primary, #101828)' }}>{title}</h6>
      <div className="d-flex align-items-center" style={{ gap: 8 }}>
        {exportUrl ? (
          <a
            href={exportUrl}
            className="btn btn-sm d-flex align-items-center"
            style={{ gap: 6, fontSize: 13, fontWeight: 500, padding: '4px 12px', borderRadius: 6, border: '1px solid var(--sl-border-primary, #d0d5dd)', background: 'var(--sl-bg-primary, #fff)', color: 'var(--sl-text-secondary, #344054)', height: 32, textDecoration: 'none' }}
          >
            Export CSV <i className="fas fa-download" style={{ fontSize: 12 }} />
          </a>
        ) : onExport ? (
          <button
            type="button"
            className="btn btn-sm d-flex align-items-center"
            style={{ gap: 6, fontSize: 13, fontWeight: 500, padding: '4px 12px', borderRadius: 6, border: '1px solid var(--sl-border-primary, #d0d5dd)', background: 'var(--sl-bg-primary, #fff)', color: 'var(--sl-text-secondary, #344054)', height: 32 }}
            onClick={onExport}
          >
            Export CSV <i className="fas fa-download" style={{ fontSize: 12 }} />
          </button>
        ) : null}

        <div style={{ position: 'relative' }}>
          <button
            type="button"
            className="btn btn-sm d-flex align-items-center"
            onClick={() => setTableSettingsOpen(!tableSettingsOpen)}
            style={{ fontSize: 13, fontWeight: 500, padding: '4px 12px', borderRadius: 6, border: '1px solid var(--sl-border-primary, #d0d5dd)', background: 'var(--sl-bg-primary, #fff)', color: 'var(--sl-text-secondary, #344054)', height: 32 }}
          >
            <i className="fas fa-columns mr-2" style={{ fontSize: 12 }} />
            Table Settings
            {hiddenColumns.length > 0 && (
              <span className="ml-1" style={{ background: 'var(--sl-fg-brand, #1982c4)', color: 'var(--sl-text-white, #fff)', borderRadius: 10, padding: '0 6px', fontSize: 11, fontWeight: 600, lineHeight: '18px' }}>
                {hiddenColumns.length}
              </span>
            )}
          </button>
          <TableSettings
            isOpen={tableSettingsOpen}
            onClose={() => setTableSettingsOpen(false)}
            visibleFields={visibleColumns}
            hiddenFields={hiddenColumns}
            onFieldsChange={onColumnsChange}
          />
        </div>

        <div className="reporting-sort-popover" style={{ position: 'relative' }}>
          <button
            type="button"
            className="btn btn-sm d-flex align-items-center"
            onClick={() => setSortPopoverOpen(!sortPopoverOpen)}
            style={{ fontSize: 13, fontWeight: 500, padding: '4px 12px', borderRadius: 6, border: '1px solid var(--sl-border-primary, #d0d5dd)', background: 'var(--sl-bg-primary, #fff)', color: 'var(--sl-text-secondary, #344054)', height: 32 }}
          >
            <i className="fas fa-sort mr-2" style={{ fontSize: 12 }} />
            Sort{sortRules.length > 1 ? ` (${sortRules.length})` : ''}
          </button>
          <SortPopover
            isOpen={sortPopoverOpen}
            onClose={() => setSortPopoverOpen(false)}
            sortRules={sortRules}
            sortableColumns={sortableColumns}
            sortTypes={sortTypes}
            onSortRuleChange={onSortRuleChange}
            onAddSortRule={onAddSortRule}
            onRemoveSortRule={onRemoveSortRule}
            isMobile={isMobile}
          />
        </div>

        {extraButtons}
      </div>
    </div>
  );
}

export default ReportingTableToolbar;
